import { useGateValue } from '@statsig/react-bindings';

export default function useIsNomad2Enabled() {
  return useGateValue('nomad_2_rollout');
}
